
import { Component, OnInit } from '@angular/core';
import { Beneficiario, DataBack, SolicitudesUtil, Titular } from './DetalleSolicitudModels';
import { RequestService } from 'src/app/core/services/request/request.service';
import { ActivatedRoute } from '@angular/router';
import { ModalVariadoService } from 'src/app/core/services/modal-variado/modal-variado.service';
import { NotificationService } from 'src/app/core/services/notification/notification.service';
import { take } from 'rxjs/operators';
import { EstadoHomologacionHelper } from 'src/app/core/helpers/solicitudes/EstadoHomologacionHelper';
import { environment } from 'src/environments/environment';
import { TealiumService } from 'src/app/tealium/TealiumService';

@Component({
    selector: 'app-detalle-solicitud-devolucion',
    templateUrl: './detalle-solicitud-devolucion.component.html',
    styleUrls: ['./detalle-solicitud-devolucion.component.scss'],
    standalone: false
})
export class DetalleSolicitudDevolucionComponent implements OnInit {

  private _timestampCarga: number = new Date().getTime();

  fechaCreacion: any;
  FechaActualizacion: any;
  solicitudDetalle: any = null;
  solicitudId = '';
  /** Inicializaciones seguras para evitar undefined en la plantilla */
  beneficiario: Beneficiario = { nombre: 'N/A', parentesco: 'N/A', numDoc: 'N/A', tipoDoc: 'N/A' };
  titular: Titular = { nombre: 'N/A', parentesco: 'Titular', numDoc: 'N/A', tipoDoc: 'N/A' };
  util = SolicitudesUtil;

  complementosAgrupados: {
    [tipo: string]: {
      parentesco: string;
      numeroDocumento: string;
      nombre: string;
      fechaActualizacion: string;
      estado: string;
    }[]
  } = {};

  data: any;
  documentosConArchivos: any[] = [];
  blobStorageBaseUrl: string = environment.BLOB_STORAGE_BASE_URL;
  panelVisibility: boolean[] = [];
  allDocumentsUploaded: boolean[] = [];
  nombreTitular: string = '';
  isAjustes = false;

  constructor(
    public requestService: RequestService,
    private route: ActivatedRoute,
    public _ModalVariadoService: ModalVariadoService,
    public notificacionService: NotificationService,
    private tealium: TealiumService
  ) { }

  ngOnInit(): void {

    /** se adiciona tageo de para analytics de HU05 */
    this.tealium.trackView({
      'event': 'ga_event',
      'eventName': 'click',
      'seccion': 'Ajustes en documentos de subsidio y/o afiliación',
      'page_path': '/detalle-solicitud-devolucion',
      'label': 'Detalle',
      'link_url': '/detalle-solicitud-devolucion',
      'link_text': 'Detalle',
      'radicado': this.route.snapshot.paramMap.get('id'),
      'estado': 'Estado General de la Solicitud'
    })
    
    const navigation = window.history.state as { data?: any; fullProcess?: any; isAjustes?: boolean };
    this.data = navigation?.data ?? null;
    const fullProcess = navigation?.fullProcess ?? null;

    if (this.data) {
      this.isAjustes = true;

      /** Titular “rápido” desde content (para cabecera) */
      this.titular = this.mapearTitular(this.data.content);
      this.nombreTitular = this.obtenerNombresApellidosTitular(this.data) || this.titular?.nombre || '';

      /** Beneficiario: NO desde content; se poblará desde PAD (spouse/packs) o backend */
      this.beneficiario = { nombre: 'N/A', parentesco: 'N/A', numDoc: 'N/A', tipoDoc: 'N/A' };

      /** Si llegó respaldo con processAffiliationData, úsalo ya (spouse/packs) */
      if (fullProcess?.processAffiliationData) {
        this.poblarBeneficiarioDesdePAD(fullProcess);
        this.solicitudDetalle = fullProcess;
        this.agruparPorComplementos();
      }

      /** UI de acordeones por bloques */
      if (this.data?.documentos) {
        const totalkeys = Object.keys(this.data.documentos).length;
        this.panelVisibility = new Array(totalkeys).fill(true);
        this.allDocumentsUploaded = new Array(totalkeys).fill(false);
      } else {
        this.panelVisibility = [];
        this.allDocumentsUploaded = [];
      }

      this.fechaCreacion = this.data.create_at;
      this.FechaActualizacion = this.data.update_at;
      /** Si no vino respaldo con PAD, intenta fetch por id de la ruta */
      const idParam = this.route.snapshot.paramMap.get('id');
      if (!fullProcess && idParam) {
        this.solicitudId = idParam;
        this.obtenerDetalle();
      }
    } else {
      // Acceso directo / F5: solo fetch por id de la ruta
      this.solicitudId = this.route.snapshot.paramMap.get('id') ?? '';
      if (this.solicitudId) this.obtenerDetalle();
    }
  }


  /** Getter unificado para mostrar el nombre del titular en la UI */
  get nombreTitularUI(): string {
    // 1) normalizado por extraerDeObjetoPlano
    const n1 = this.titular?.nombre && this.titular.nombre !== 'N/A' ? this.titular.nombre : '';

    // 2) valor previo (cuando viene por ajustes)
    const n2 = this.nombreTitular && this.nombreTitular !== 'N/A' ? this.nombreTitular : '';

    // 3) desde solicitudesEntity del primer documento (ajuste técnico)
    const n3 = (() => {
      try {
        const bloques = this.data?.documentos;
        const primerBloque = bloques ? (Object.values(bloques)[0] as any) : null;
        const solicitud = primerBloque?.documentos?.[0]?.documento?.solicitudesComplementosEntity?.solicitudesEntity;
        if (!solicitud) return '';
        const armado = `${solicitud?.primerNombreTitular || ''} ${solicitud?.segundoNombreTitular || ''} ${solicitud?.primerApellidoTitular || ''} ${solicitud?.segundoApellidoTitular || ''}`
          .replace(/\s+/g, ' ').trim();
        return armado || '';
      } catch { return ''; }
    })();

    // 4) nombre completo del documento (si existiera)
    const n4 = (() => {
      try {
        const bloques = this.data?.documentos;
        const primerBloque = bloques ? (Object.values(bloques)[0] as any) : null;
        return primerBloque?.documentos?.[0]?.nombreCompleto || '';
      } catch { return ''; }
    })();

    return n1 || n2 || n3 || n4 || 'N/A';
  }
  obtenerDetalle(): void {
    if (!this.solicitudId) return;

    this.requestService.obtenerDetalleSolicitud(this.solicitudId).subscribe({
      next: (detalle) => this.hidratarDetalle(detalle),
      error: (error) => {
        console.error('Error al obtener el detalle:', error);
      }
    });
  }

  /** Centraliza hidratación de titular/beneficiario y la agrupación */
  private hidratarDetalle(detalle: any): void {
    this.solicitudDetalle = detalle;

    // Titular desde backend si el “rápido” quedó en N/A
    const tBackend = detalle?.titular ?? detalle?.processAffiliationData?.processTitular;
    if ((!this.titular || this.titular?.nombre === 'N/A') && tBackend) {
      this.titular = this.extraerDeObjetoPlano(tBackend, 'Titular') as Titular;
      this.nombreTitular = this.titular.nombre || this.nombreTitular;
    }

    // Beneficiario con prioridad a cónyuge y luego packs
    this.poblarBeneficiarioDesdePAD(detalle);

    // Agrupación de complementos
    this.agruparPorComplementos();
  }


  private poblarBeneficiarioDesdePAD(source: any): void {
    const packs = Array.isArray(source?.processAffiliationData?.processPacks)
      ? source.processAffiliationData.processPacks
      : [];
    const spouse = source?.processAffiliationData?.processSpouse ?? null;

    // 1. Prioridad: Ajustes (solo si tiene nombre real)
    const benefAjuste = this.extraerBeneficiarioDesdeAjuste();
    if (benefAjuste && benefAjuste.nombre !== 'N/A') {
      this.beneficiario = benefAjuste;
      return;
    }

    // 2. Prioridad: Packs (Hijos, hermanos, etc.)
    if (packs.length > 0) {
      const packValido = packs.find((p: any) => p.fullName || p.numDocument || p.nombreCompleto);
      if (packValido) {
        this.beneficiario = this.extraerDeObjetoPlano(packValido, packValido?.tipoParentesco || 'Beneficiario');
        return;
      }
    }

    // 3. Prioridad: Cónyuge (Validando que tenga datos para evitar el falso positivo)
    // Solo entra aquí si el objeto spouse tiene nombre o documento
    if (spouse && (spouse.fullName || spouse.numDocument || spouse.nombreCompleto)) {
      this.beneficiario = this.extraerDeObjetoPlano(spouse, spouse.tipoParentesco || 'Cónyuge');
      return;
    }

    // 4. SI NO HAY NADIE VALIDO: Forzar todos los campos a 'N/A'
    this.beneficiario = {
      nombre: 'N/A',
      parentesco: 'N/A',
      numDoc: 'N/A',
      tipoDoc: 'N/A'
    };
  }



  private extraerBeneficiarioDesdeAjuste(): Beneficiario | null {
    try {
      const bloques = this.data?.documentos;
      const primerBloque = bloques ? (Object.values(bloques)[0] as any) : null;
      const doc0 = primerBloque?.documentos?.[0]?.documento;
      const se = doc0?.solicitudesComplementosEntity?.solicitudesEntity;
      if (!se) return null;

      const nombre = `${se?.primerNombreBeneficiario || ''} ${se?.segundoNombreBeneficiario || ''} ${se?.primerApellidoBeneficiario || ''} ${se?.segundoApellidoBeneficiario || ''}`
        .replace(/\s+/g, ' ')
        .trim();

      const parentesco =
        se?.tipoParentescoBeneficiario
        || se?.parentescoBeneficiario
        || 'N/A';

      const numDoc =
        se?.numeroDocumentoBeneficiario
        || se?.beneficiarioNumeroDocumento
        || 'N/A';

      const tipoDoc =
        se?.tipoIdentidadBeneficiario
        || se?.beneficiarioTipoIdentidad
        || 'N/A';

      // Si no hay nombre en campos separados, intenta nombreCompleto
      const nombreAlt = doc0?.nombreCompleto || '';
      const finalNombre = (nombre || nombreAlt || 'N/A').trim();

      return {
        nombre: finalNombre || 'N/A',
        parentesco: parentesco || 'N/A',
        numDoc: String(numDoc || 'N/A'),
        tipoDoc: String(tipoDoc || 'N/A'),
      };
    } catch {
      return null;
    }
  }


  agruparPorComplementos(): void {
    this.complementosAgrupados = {};
    if (!this.solicitudDetalle) return;

    const titular = this.solicitudDetalle.titular
      ?? this.solicitudDetalle.processAffiliationData?.processTitular
      ?? null;

    const spouse = this.solicitudDetalle.processAffiliationData?.processSpouse ?? null;

    const packs = Array.isArray(this.solicitudDetalle.processAffiliationData?.processPacks)
      ? this.solicitudDetalle.processAffiliationData.processPacks
      : [];

    const integrantes: any[] = [
      titular ? { ...titular, __rol__: 'Titular' } : null,
      spouse ? { ...spouse, __rol__: (spouse?.tipoParentesco || spouse?.parentesco || 'N/A') } : null,
      ...packs.map((p: any) => ({
        ...p,
        __rol__: (p?.tipoParentesco || p?.parentesco || 'Beneficiario')
      }))
    ].filter(Boolean);

    integrantes.forEach((pers: any) => {
      const complementos = Array.isArray(pers?.complementos) ? pers.complementos : [];
      const norm = this.extraerDeObjetoPlano(pers, pers.__rol__);

      complementos.forEach((c: any) => {
        const tipo =
          c?.tipo ??
          c?.tipoComplemento ??
          c?.codigoTipo ??
          c?.clave ??
          'OTRO';

        const tipoKey = String(tipo); // <- asegurar string

        if (!this.complementosAgrupados[tipoKey]) {
          this.complementosAgrupados[tipoKey] = [];
        }

        const fechaActualizacion =
          c?.actualizacion ??
          c?.fechaActualizacion ??
          c?.updatedAt ??
          c?.fecha ??
          '';

        const estado =
          c?.estado ??
          c?.status ??
          c?.estadoDocumento ??
          'N/A';

        const numeroDocumento =
          norm?.numDoc
          ?? pers?.numeroDocumento
          ?? this.solicitudDetalle?.numeroIdentidadTitular
          ?? 'N/A';

        this.complementosAgrupados[tipoKey].push({
          parentesco: norm?.parentesco || 'N/A',
          numeroDocumento: String(numeroDocumento || 'N/A'),
          nombre: norm?.nombre || 'N/A',
          fechaActualizacion: String(fechaActualizacion || ''),
          estado: String(estado || 'N/A'),
        });
      });
    });

    Object.keys(this.complementosAgrupados).forEach((k) => {
      const arr = this.complementosAgrupados[k];
      arr.sort((a, b) => {
        const da = a?.fechaActualizacion ? new Date(a.fechaActualizacion).getTime() : 0;
        const db = b?.fechaActualizacion ? new Date(b.fechaActualizacion).getTime() : 0;
        return db - da;
      });
    });
  }

  objectKeys(obj: any): string[] {
    return obj ? Object.keys(obj) : [];
  }


  getBlobUrl(fileName: string): string {
    if (!fileName) return '';
    const safe = encodeURIComponent(fileName);
    return `${this.blobStorageBaseUrl}${safe}?nocache=${this._timestampCarga}`;
  }

  actualizarTimestamp() {
    this._timestampCarga = new Date().getTime();
  }

  enviarTodosDocumentos(index: number, key: any): void {
    if (this.documentosConArchivos.length === 0) {
      alert('Por favor seleccione al menos un archivo para enviar.');
      return;
    }

    this.data.documentos[key].documentos.forEach(documento => {
      this.enviarDocumento(documento);
    });
    this.panelVisibility[index] = false;
    this._ModalVariadoService.modalConfirmacion('Tu documento ha sido cargado exitosamente. Recibirás una notificación cuando sea validado.');
  }

  enviarDocumento(documento: any): void {
    if (!documento.selectedFile) {
      alert('Por favor seleccione un archivo.');
      return;
    }

    this.requestService.actualizarDocumento(
      documento.documento.id,
      documento.documento.url,
      documento.selectedFile
    ).subscribe({
      next: (response: any) => {
        this.actualizarTimestamp();
        if (response?.status === 200 || response?.status === 'success') {
          console.log('Documento actualizado correctamente');
        } else {
          alert('El servidor respondió, pero no fue exitoso.');
          console.error('Respuesta inesperada:', response);
        }
      },
      error: (err: any) => {
        this.refrescarEstadosBadge();
        console.error('Error al enviar documento:', err);
      }
    });
  }

  onFileSelected(event: any, documento: any, key: string, i: number) {
    const file = event.target.files[0];
    if (file && file.type === 'application/pdf') {
      documento.selectedFile = file;

      const index = this.documentosConArchivos.findIndex(d => d.id === documento.id);
      if (index === -1) {
        this.documentosConArchivos.push(documento);
      } else {
        this.documentosConArchivos[index] = documento;
      }

      this.checkAllDocumentsUploaded(key, i);
    } else {
      alert('Solo se permiten archivos PDF.');
    }
  }

  removeFile(documento: any, fileInput: any, key: string, i: number) {
    documento.selectedFile = null;
    fileInput.value = null;

    const index = this.documentosConArchivos.findIndex(d => d.id === documento.id);
    if (index !== -1) {
      this.documentosConArchivos.splice(index, 1);
    }

    this.checkAllDocumentsUploaded(key, i);
  }

  checkAllDocumentsUploaded(key: string, index: number) {
    const allUploaded = this.data.documentos[key].documentos.every(doc => doc.selectedFile);
    this.allDocumentsUploaded[index] = allUploaded;
  }

  obtenerTipoPersona(key: string): string {
    if (!this.data?.documentos || !this.data.documentos[key]) {
      return 'Trámite';
    }

    const documentos = this.data.documentos[key].documentos;
    if (!documentos || documentos.length === 0) {
      return 'Trámite';
    }

    const sigla = documentos[0]?.documento?.solicitudesComplementosEntity?.solicitudesTipos?.sigla;

    switch (sigla) {
      case 'AFT':
        return 'Titular';
      case 'AFB':
        return 'Beneficiario';
      default:
        return 'Beneficiario';
    }
  }


  obtenerNombresApellidosTitular(data: any): string {

    const documentosKeys = Object.keys(data.documentos || {});
    if (documentosKeys.length === 0) return '';

    const solicitud = data.documentos[documentosKeys[0]].documentos[0].documento.solicitudesComplementosEntity.solicitudesEntity;
    return `${solicitud?.primerNombreTitular || ''} ${solicitud?.segundoNombreTitular || ''} ${solicitud?.primerApellidoTitular || ''} ${solicitud?.segundoApellidoTitular || ''}`.trim().replace(/\s+/g, ' ');
  }

  obtenerNombreEstado(codigoEstado: any): string {
    return EstadoHomologacionHelper.obtenerNombreGrupo(codigoEstado);
  }

  obtenerObservaciones(observaciones: string): string {
    if (!observaciones) return '';
    try {
      const parsed = JSON.parse(observaciones);
      return parsed.observaciones || observaciones;
    } catch {
      return observaciones;
    }
  }

  /**
   * Normaliza y extrae la información del primer beneficiario desde content (se mantiene por compatibilidad),
   * pero recuerda: en AFT el content solo trae titular, no lo uses en ngOnInit para beneficiarios.
   */
  mapearPrimerBeneficiario(data: DataBack | string): Beneficiario {
    try {
      let contenidoObj;
      if (typeof data === 'string') {
        contenidoObj = JSON.parse(data);
      } else if (data && (data as any).content) {
        contenidoObj = typeof (data as any).content === 'string' ? JSON.parse((data as any).content) : (data as any).content;
      } else {
        contenidoObj = data;
      }
      const b = contenidoObj?.beneficiario || contenidoObj?.beneficiarios?.[0];
      if (b && b.datosBasicos) {
        return {
          nombre: `${b.datosBasicos.primerNombre || ''} ${b.datosBasicos.segundoNombre || ''} ${b.datosBasicos.primerApellido || ''} ${b.datosBasicos.segundoApellido || ''}`.replace(/\s+/g, ' ').trim(),
          parentesco: b.parentesco?.tipoParentesco || 'N/A',
          numDoc: b.identidad?.numero || 'N/A',
          tipoDoc: b.identidad?.tipo || 'N/A'
        };
      }
    } catch (e) { console.error(e); }
    return { nombre: 'N/A', parentesco: 'N/A', numDoc: 'N/A', tipoDoc: 'N/A' };
  }

  /** Mapeo tolerante de titular desde content (soporta titular en raíz de content) */
  mapearTitular(data: DataBack | string): Titular {
    try {
      let obj = typeof data === 'string'
        ? JSON.parse(data)
        : (data as any).content
          ? (typeof (data as any).content === 'string' ? JSON.parse((data as any).content) : (data as any).content)
          : data;

      const t = obj?.titular ?? (obj?.datosBasicos ? obj : undefined);
      if (t) return this.extraerDeObjetoPlano(t, 'Titular') as Titular;
    } catch (e) { console.error(e); }
    return { nombre: 'N/A', parentesco: 'Titular', numDoc: 'N/A', tipoDoc: 'N/A' };
  }

  /**
   * Normaliza y extrae una persona (Titular/Beneficiario/Cónyuge) desde variantes de estructura:
   *  - datosBasicos o plano
   *  - alias frecuentes (nombres/apellidos anidados, nombreCompleto, *Titular de solicitudesEntity)
   *  - documento (identidad.numero / numeroDocumento / numeroIdentidadTitular)
   */
  private extraerDeObjetoPlano(p: any, rol: string) {
    if (!p) return { nombre: 'N/A', parentesco: rol || 'N/A', numDoc: 'N/A', tipoDoc: 'N/A' };

    // Priorizamos el objeto directo
    const datos = p.datosBasicos ?? p;

    // 1. Nombre: Prioridad a fullName 
    const nombre = (
      datos.fullName ??
      datos.nombreCompleto ??
      `${datos.primerNombre || ''} ${datos.primerApellido || ''}`.trim()
    ) || 'N/A';

    // 2. Documento: Prioridad a numDocument y typeDocument
    const numDoc = p.numDocument ?? p.numeroDocumento ?? p.identidad?.numero ?? 'N/A';
    const tipoDoc = p.typeDocument ?? p.tipoDocumento ?? p.identidad?.tipo ?? 'N/A';

    // 3. Parentesco: Prioridad a tipoParentesco
    const parentesco = p.tipoParentesco ?? p.parentesco ?? rol ?? 'N/A';

    return {
      nombre: nombre.trim(),
      parentesco,
      numDoc: String(numDoc),
      tipoDoc: String(tipoDoc)
    };
  }

  get tipoDocBenefUI(): string {
    // Si el objeto beneficiario dice N/A, devolvemos N/A de inmediato
    if (!this.beneficiario || this.beneficiario.tipoDoc === 'N/A') {
      return 'N/A';
    }

    const raw = this.beneficiario.tipoDoc;
    const hom = this.util?.homologarTipoDocuBeneficiario?.(raw);

    // Si el homologador falla o no reconoce el código, mostramos el valor crudo o N/A
    return (!hom || /desconocido/i.test(hom)) ? raw : hom;
  }

  get numDocBenefUI(): string {
    // Si no hay beneficiario o es N/A, devolvemos N/A
    if (!this.beneficiario || this.beneficiario.numDoc === 'N/A') {
      return 'N/A';
    }
    return String(this.beneficiario.numDoc);
  }

  refrescarEstadosBadge() {
    const idActual =
      this.data?.id ??
      this.solicitudDetalle?.id ??
      this.solicitudId ??
      null;

    if (!idActual) return;

    this.requestService.devolucionesIds$.pipe(take(1)).subscribe(idsActuales => {
      const idsFiltrado = idsActuales.filter(id => String(id) !== String(idActual));
      this.requestService.actualizarIdsDevoluciones(idsFiltrado);
      this.notificacionService.setNumDevoluciones(idsFiltrado.length);
    });
  }

}
